import React, { forwardRef } from 'react';
import PropTypes from 'prop-types';
import clsx from 'clsx';
import { USER_OPERATIONS } from '../../constants';
import { Button } from '@material-ui/core';
import { useAllowedOperationsContext } from '../../hocs/withAllowedOperationsProvider/withAllowedOperationsProvider';
import styles from './AuthEnabledButton.module.css';

const AuthEnabledButton = forwardRef(
  (
    {
      operation,
      useNativeButton,
      className,
      ButtonComponent,
      isIconButton,
      disable,
      disabled,
      ...buttonProps
    },
    ref,
  ) => {
    const { allowedOperations } = useAllowedOperationsContext();
    const isAuthorized = allowedOperations.includes(operation);
    const readOnlyClass = isIconButton ? 'readOnlyIcon' : 'readOnly';

    const FinalButtonComponent =
      ButtonComponent || (useNativeButton ? 'button' : Button);
    return (
      <FinalButtonComponent
        ref={ref}
        className={clsx(className, !isAuthorized && styles[readOnlyClass])}
        disable={!isAuthorized || disable}
        disabled={!isAuthorized || disabled}
        {...buttonProps}
      />
    );
  },
);

AuthEnabledButton.propTypes = {
  operation: PropTypes.oneOf(Object.values(USER_OPERATIONS)),
  useNativeButton: PropTypes.bool,
  className: PropTypes.string,
  ButtonComponent: PropTypes.elementType,
  isIconButton: PropTypes.bool,
};

export default AuthEnabledButton;
